<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaNivel3')}} </h4>
        </div>
        <form class="add-user-form" id="add-level2">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'nivel1'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel1')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-sitemap"></i>
                            </div>
                            <v-select v-model="select_level1" :options="level1" label="name" @input="getSubcategoriesByCategory()"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'nivel2'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel2')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-sitemap"></i>
                            </div>
                            <v-select v-model="select_level2" :options="level2" label="name"></v-select>
                        </div>
                        <div v-else>
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :data-vv-as="input_field.labelName"
                                   v-bind:name="input_field.inputName"
                                   v-bind:id="input_field.inputName">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                             <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                    <div class="single-vselect">
                        <h4>{{$t('placeholder.punereInFunctiune')}}</h4>
                        <v-select v-model="pif" label="label" :options="pifs"></v-select>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons">
                    <button @click.prevent='addLevel()' :disabled="this.$store.state.loading">
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Level1Service from '../../api-services/nivel1.service.js'
import Level3Service from '../../api-services/nivel3.service.js'

export default {
  name: 'addsubtypes',
  data () {
    return {
      level3: [],
      level2: [],
      level1: [],
      select_level1: null,
      select_level2: null,
      pif: null,
      selected_label: null,
      input_fields: {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.level3) ? this.level3.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.level3 && this.level3.nivel1) ? this.level3.nivel1.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'nivel2',
            labelName: this.$t('placeholder.subcategorie'),
            inputValue: (this.level3) ? this.level3.nivel2.name : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'addition_min',
            labelName: this.$t('placeholder.addition_min'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_distribution',
            labelName: this.$t('placeholder.addition_distribution'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_partner',
            labelName: this.$t('placeholder.addition_partner'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_retail',
            labelName: this.$t('placeholder.addition_retail'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          }
        ]
      }
    }
  },
  methods: {
    addLevel () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-level2'))
      if (this.select_level1) {
        formData.append('nivel1', this.select_level1.id)
      }
      if (this.select_level2) {
        formData.append('nivel2', this.select_level2.id)
      }
      if (this.pif.id) {
        formData.append('pif', this.pif.inputValue)
      }
      Level3Service.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.nivel3Adaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'subtypes' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    getCategories () {
      Level1Service.getAll().then((response) => {
        this.level1 = response.data.data
        this.$store.dispatch('hideLoading')
      })
    },
    getSubcategoriesByCategory () {
      Level1Service.get(this.select_level1.id).then((response) => {
        this.level2 = response.data.data.nivel2
        this.$store.dispatch('hideLoading')
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    }
  },
  computed: {
    pifs () {
      return [
        {
          'id': 1,
          'inputValue': 0,
          'label': this.$t('placeholder.nuNecesitaPif'),
          'inputName': 'PIF'
        },
        {
          'id': 2,
          'inputValue': 1,
          'label': this.$t('placeholder.necesitaPif'),
          'inputName': 'PIF'
        }
      ]
    }
  },
  created () {
    this.getCategories()
    this.pif = this.pifs[0]
    this.$store.dispatch('hideLoading')
  }
}
</script>
